import classes from "./styles/style.module.css";
import CustomModal from "../../../assets/components/ModalComonent";
import CustomButton from "../../../assets/components/CustomButton";
import TimerImg from "../../../assets/images/icons/durationDialogIcon.png";
import { useNavigate } from "react-router-dom";

const WordGameEndTimeDialog = ({ showDialog }) => {
  const navigate = useNavigate();
  const handleClose = () => {
    navigate(-1, { replace: true });
  };
  const modalContent = (
    <>
      <div className="w-100 text-center">
        <img src={TimerImg} alt="InfoIcon" className={classes.alertBanner} />
        <p className={classes.title}>پایان</p>
        <div className={classes.dialogContent}>
          <p className="text-center">زمان شما به پایان رسید</p>
        </div>
        <div className="w-75 mx-auto mt-4">
          <CustomButton
            clickHandler={handleClose}
            color={"primary"}
            shadow
            text={"بازگشت"}
          />
        </div>
      </div>
    </>
  );
  return (
    <CustomModal
      open={showDialog}
      closeHandler={handleClose}
      inputDialog={true}
      dialogContent={modalContent}
    />
  );
};

export default WordGameEndTimeDialog;
